import { render } from "./Overlay.vue?vue&type=template&id=3e9492ea"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"
script.render = render

export default script